import { currencyFormatter } from "../../../shared/PersistentSummary/UtilsHelper";
import {
  monthlyPayments,
  upfrontPaymentsTotal,
} from "../../../shared/PersistentSummary/helpers/PersistentPaymentSummaryHelper";
import { PriceSummary } from "./PriceSummary";
import type { CartPriceSummaryProps } from "./types";

export const CartPriceSummary = ({ cartPriceModel }: CartPriceSummaryProps) => {
  const { productsInformation, currency, totalPaymentAmount } = cartPriceModel;

  return (
    <PriceSummary
      downpayment={upfrontPaymentsTotal(productsInformation, currency)}
      installments={monthlyPayments(productsInformation, currency).map(p => ({
        label: p.labels[0],
        value: p.value,
      }))}
      total={currencyFormatter(currency).format(totalPaymentAmount)}
    />
  );
};

CartPriceSummary.displayName = "CartPriceSummary";
